/**
 * ProgressBar — compact progress indicator for the Due Diligence Vault.
 * Uses .ddv-progress CSS classes for responsive layout.
 */
const ProgressBar = ({ percent }) => (
  <div className="ddv-progress">
    <div className="ddv-progress__labels">
      <p className="ddv-progress__heading">Due Diligence Review Progress</p>
      <p className="ddv-progress__percent">{percent}% Complete</p>
    </div>
    <div className="ddv-progress__track">
      <div className="ddv-progress__fill" style={{ width: `${percent}%` }} />
    </div>
  </div>
);

export default ProgressBar;
